// extracted by mini-css-extract-plugin
export default {"snakeDot":"snake_snakeDot__yugco"};